import React from "react";
import styles from "./button.module.css";

const Button = ({ children, onClick, type = "button", variant = "primary", disabled = false, style }) => {
  return (
    <button
      className={`${styles.button} ${styles[variant]}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;